// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1S-_b","requiredAsterisk":"Info_requiredAsterisk__2HFuB"};